"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var configurationTypes_1 = require("../../../shared/types/configurationTypes");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var DropDownComponent_1 = __importDefault(require("../../../shared/components/FormComponents/DropDownComponent"));
var getColumnEditLayout_1 = __importDefault(require("../../../shared/util/getColumnEditLayout"));
var RadioComponent_1 = __importDefault(require("../../../shared/components/FormComponents/RadioComponent"));
var CrudeEnumSelection_1 = __importDefault(require("./CrudeEnumSelection"));
var CrudeTextInputComponent_1 = __importDefault(require("./CrudeTextInputComponent"));
var IconComponent_1 = __importDefault(require("../../../shared/components/FormComponents/IconComponent"));
var FolderOpen_1 = __importDefault(require("@mui/icons-material/FolderOpen"));
var CrudeEnumComponent = function (props) {
    var _a, _b, _c, _d, _e;
    var columnName = props.schema.name;
    var entity = props.entity;
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var editLayout = react_redux_1.useSelector(crude_selector_1.getEditLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var columnLabels = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[props.entity]) === null || _b === void 0 ? void 0 : _b.columns;
    var label = (columnLabels && ((_c = columnLabels[columnName]) === null || _c === void 0 ? void 0 : _c.title)) ? (_d = columnLabels[columnName]) === null || _d === void 0 ? void 0 : _d.title : columnName;
    var description = columnLabels && ((_e = columnLabels[columnName]) === null || _e === void 0 ? void 0 : _e.description);
    var _f = react_1.useState(props.columnEditLayout || (editLayout && getColumnEditLayout_1.default(entity, columnName || '', editLayout))), columnEditLayout = _f[0], setColumnEditLayout = _f[1];
    react_1.useEffect(function () {
        setColumnEditLayout(props.columnEditLayout);
    }, [props.columnEditLayout]);
    var layout = react_1.default.useMemo(function () {
        var _a, _b;
        return (columnEditLayout && columnEditLayout.layout
            ? columnEditLayout.layout
            : (((_a = appLayout.globalInputLayouts) === null || _a === void 0 ? void 0 : _a.enum) ? (_b = appLayout.globalInputLayouts) === null || _b === void 0 ? void 0 : _b.enum : configurationTypes_1.EnumLayout.dropdown));
    }, [columnEditLayout, appLayout]);
    var _g = react_1.useState(false), selectEnum = _g[0], setSelectEnum = _g[1];
    var _h = react_1.default.useState(props.data), data = _h[0], setData = _h[1];
    var _j = react_1.useState([]), options = _j[0], setOptions = _j[1];
    var _k = react_1.useState(), value = _k[0], setValue = _k[1];
    var translateOptions = function () {
        var _a;
        var dataOpt = [];
        var values = (_a = props.schema.enumValues) !== null && _a !== void 0 ? _a : [];
        values.length > 0 && values.map(function (key) {
            var _a, _b, _c, _d;
            var obj = {
                key: key,
                value: (columnLabels && columnLabels[columnName] && columnLabels[columnName].options && ((_a = columnLabels[columnName]) === null || _a === void 0 ? void 0 : _a.options[key]))
                    ? (_b = columnLabels[columnName]) === null || _b === void 0 ? void 0 : _b.options[key].title : key,
                description: (columnLabels && columnLabels[columnName] && columnLabels[columnName].options && ((_c = columnLabels[columnName]) === null || _c === void 0 ? void 0 : _c.options[key])) && ((_d = columnLabels[columnName]) === null || _d === void 0 ? void 0 : _d.options[key].description),
            };
            dataOpt.push(obj);
        });
        setOptions(dataOpt);
        setValue((dataOpt.length > 0)
            ? dataOpt.find(function (element) {
                return element.key === props.data.data[columnName];
            })
            : (props.schema.nullable ? undefined : dataOpt[0]));
    };
    react_1.useEffect(function () {
        translateOptions();
    }, [data]);
    react_1.useEffect(function () {
        setData(props.data);
    }, [props.data]);
    var changeData = function (value) {
        var newData = data;
        var newColumnData = newData.data;
        newColumnData[columnName] = value;
        newData.data = newColumnData;
        setData(__assign({}, newData));
        props.onChange && props.onChange(newData);
    };
    var disabled = props.disabled ? props.disabled : false;
    return (react_1.default.createElement(react_1.default.Fragment, null, (layout === configurationTypes_1.EnumLayout.radio)
        ? (react_1.default.createElement(RadioComponent_1.default, { disabled: disabled, options: options, value: value, description: description, label: label, onChange: function (value) {
                changeData(value);
            } }))
        : (react_1.default.createElement(react_1.default.Fragment, null, appLayout.maxDropdownSize && appLayout.maxDropdownSize <= options.length
            ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CrudeTextInputComponent_1.default, { showTooltip: true, notDisabledValue: true, fullWidth: props.fullWidth, schema: props.schema, id: props.id, entity: props.entity, data: data, clearable: props.schema.nullable, disabled: true, endIcon: react_1.default.createElement(IconComponent_1.default, { icon: react_1.default.createElement(FolderOpen_1.default, null), onClick: function () { return setSelectEnum(true); } }) }),
                selectEnum &&
                    react_1.default.createElement(CrudeEnumSelection_1.default, { disabled: disabled, disableClearable: !props.schema.nullable, options: options, label: label, description: description, value: value, onClose: function () { return setSelectEnum(false); }, onChange: function (value) {
                            var newValue = value ? value.key : undefined;
                            changeData(newValue);
                            setSelectEnum(false);
                        } })))
            : (react_1.default.createElement(DropDownComponent_1.default, { disabled: disabled, description: description, disableClearable: !props.schema.nullable, options: options, label: label, fullWidth: props.fullWidth, value: value, onChange: function (value) {
                    var newValue = value ? value.key : undefined;
                    changeData(newValue);
                } }))))));
};
exports.default = CrudeEnumComponent;
